
import axios from '../../utils/request';
import React, { Component } from 'react';
import { Spinner } from 'reactstrap';

export class HisenseUpdateResumeTrigger extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            message: "",
            errorMessage: null
        };
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const commonParamater = urlParams.get("commonParamater");
        const tenantId = urlParams.get("tenantId");
        this.setState({ commonParamater: commonParamater, tenantId: tenantId });
        const params = {
            tenantId,
            commonParamater
        }
        axios
            .get("/api/Hisense/UpdateResumeTrigger", { params: params })
            .then(res => {
                console.log(res.data);
                const data = res.data;
                console.log(data);
                this.setState({ isLoading: true, message: data.data });
            }).catch(reason => {
                console.log("error 获取初始信息失败");
                const errorMessages = reason?.response?.data?.errorMessages ?? ["获取初始信息失败。"]
                this.setState({ errorMessage: errorMessages });
                this.setState({ isLoading: true });
            })
    }

    render() {
        if (this.state.isLoading) {
            if (this.state.errorMessage != null) {
                return (<div style={{ textAlign: "center", padding: "32px" }}><span style={{ color: "red" }}>{this.state.errorMessage}</span></div>)
            } else {
                return (<div style={{ textAlign: "center", padding: "32px" }}><span>{this.state.message}</span></div>)
            }
        } else {
            return (
                <div style={{ textAlign: "center", lineHeight: "100vh" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }

    }
}